import { Tag } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function IdTag({ id }) {
  return <Tag colorScheme="blue">#{id}</Tag>;
}

IdTag.defaultProps = {
  id: 0,
};

IdTag.propTypes = {
  id: PropTypes.number,
};

export default IdTag;
